var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#123c7f;stroke-miterlimit:10;stroke-width:4px;}.cls-2{fill:#123c7f;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100,142.87c-22.94-.5-42.53-9.46-59.67-24.41a115.88,115.88,0,0,1-15.48-16.67c-.85-1.11-1.33-1.93-.27-3.31C40.32,78.27,59.82,63.83,85.34,58.66c20.31-4.12,39.17.36,56.94,10.34,13,7.31,23.68,17.29,32.77,29.05.94,1.21,1.43,2.07.28,3.55C159.46,122,139.72,136.34,114,141.48a57.72,57.72,0,0,1-5.85.88C105.47,142.61,102.81,142.7,100,142.87ZM99.91,70.8a29.18,29.18,0,1,0,29.31,29.07A29.21,29.21,0,0,0,99.91,70.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100,115.79a15.84,15.84,0,0,1-2.7-31.44c1.93-.34,2.72-.21,2.7,2.2-.07,7.38,6,12.51,13.34,11.25,2.42-.42,2.61.43,2.6,2.34A15.92,15.92,0,0,1,100,115.79Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/view-icon.4b94ec3185b7a79ef5058231d04dcd81.svg";
export { ForwardRef as ReactComponent };